<template>
  <div>
    <Breadcrumbs :children="[
      {
        text: `Sucursales (${companies.length})`,
      },
    ]" />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else class="card ml-3">
      <div class="card-body">

        <router-link to="/companies/0" class="btn main-bg">
          <i class="fa fa-plus mr-1"></i>Nueva surcursal
        </router-link>
          
        <div style="overflow-y: auto; max-height: 70vh;overflow-x:auto;">
          <table class="table" id="list-supliers">
            <thead class="thead-light">
              <tr>
                <th>Pos.</th>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Direccion</th>
                <th class="text-center">Activo</th>
                <th class="text-center">Mínimo</th>
                <th class="text-center">Envio</th>
                <th class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="loading && companies.length === 0">
                <td class="text-center" colspan="8">
                  <Loader />
                </td>
              </tr>
              <tr v-for="branchO in companies" :key="branchO.id">      
                <td>{{ branchO.position || 'N/A' }}</td>
                <td>{{ branchO.name }}</td>
                <td>{{ getEstablishmentName(branchO.type) }}</td>
                <td>{{ branchO.address }}</td>
                <td class="text-center">{{ branchO.status == 1 ? 'Si' : 'No' }}</td>
                <td class="text-center">{{ branchO.minimum }}</td>
                <td class="text-center">{{ branchO.shipping_cost }}</td>
                <td class="text-center">
                  <router-link :to="`companies/${branchO.id}`" title="Detalles" class="text-info mr-2">
                    <i class="fa fa-edit"></i>
                  </router-link>
                  <router-link :to="`companies/${branchO.id}/resources`" title="Canastas, Productos ..." class="text-info mr-2">
                    <i class="fa fa-eye"></i>
                  </router-link>
                  <router-link :to="`companies/${branchO.id}/orders`" title="Ordenes" class="text-info">
                    <i class="fa fa-list"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>         

  </div>
</template>

<script>

import Loader from '../components/Loader'
import { CompanyService } from '../../services/CompanyService';
import Breadcrumbs from '../components/Breadcrumbs'

export default {
  name: "CompaniesList",
  components: {
    Loader,
    Breadcrumbs
  },
  data: function () {
    return {
      companies: [],
      companyTypes: [],
      loading: false,
      paginationData: {
        currentPage: 1,
        totalOrders: 0,
        itemsPerPage: 7,
      },
      companyService: new CompanyService(),
    };
  },
  methods: {
    async getCompanies(){
      this.loading = true;
      const res = await this.companyService.getCompanies(this.$store.getters.isAdmin ? null : [this.$store.getters.getCompany]);
      this.companies = res.companies;
      this.loading = false;
    },
    getCategoryName: function (id) {
      let name = "N/D";
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id == id) {
          name = this.categories[i].name;
          break;
        }
      }
      return name;
    },
    getEstablishmentName(id) {
      return this.companyService.getEstablishmentName(id, this.companyTypes);
    },
    async getEstablishmentTypes() {
      this.companyTypes = await this.companyService.getEstablishmentTypes();
    },
  },
  mounted: async function () {
    await this.getCompanies();
  },
  async beforeMount() {
    await this.getEstablishmentTypes();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/scss/colors";
.w100{
  width: 100%;
}
h3 {
  margin: 40px 0 0;
}
.form-panel {
  border: solid 0.1em #ccc;
  border-radius: 4px;
  margin: 4px 0 5px 0;
}
td,th{
  font-weight: 400;
}
.fa{
  font-size: 1.2rem;
}
</style>
